export default __webpack_public_path__ + "static/media/BYD_E2_04.6089ce78.jpg";